<div
  class="asterisk-with-number"
  [style.width]="asteriskSize + 'rem'"
  [style.height]="asteriskSize + 'rem'"
>
  <div class="asterisk-icon">
    <svg-icon
      class="icon-{{ asteriskColor }}"
      [src]="iconSrc"
      [svgStyle]="{ 'width.rem': asteriskSize, 'height.rem': asteriskSize }"
    >
    </svg-icon>
  </div>
  <div
    class="number"
    [style.color]="numberColor"
    [style.font-size]="numberSize + 'rem'"
    [style.font-weight]="fontWeight"
  >
    {{ number }}
  </div>
</div>
